import * as actions from '../actionTypes'
const initialState = {
    selectedStudent: null,
    selectedSubjectInstance: null,

};

const selectionReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.UNSET_SELECTED_STUDENT:
            return {
                ...state,
                selectedStudent: null,
            };
        case actions.SET_SELECTED_STUDENT:
            return {
                ...state,
                selectedStudent: action.payload,
            };
            case actions.UNSET_SELECTED_SUBJECT_INSTANCE:
                return {
                    ...state,
                    selectedSubjectInstance: null,
                };
            case actions.SET_SELECTED_SUBJECT_INSTANCE:
                return {
                    ...state,
                    selectedSubjectInstance: action.payload,
                };
        default:
            return state;
    }
};

export default selectionReducer;

